import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {ManuscriptService} from "../services/manuscript.service";
import {BookViewModel} from "../models/book-view.model";
import styled from "styled-components";
import {Grid} from "@mui/material";
import {Colors} from "../theme/colors";
import {CustomFeatherIcon} from "../components/ui-base/icons/custom-feather-icon";
import {CustomMapPinIcon} from "../components/ui-base/icons/custom-map-pin-icon";
import {CustomGlobeStandIcon} from "../components/ui-base/icons/custom-globe-stand-icon";
import {CustomHourglassIcon} from "../components/ui-base/icons/custom-hourglass-icon";
import {CustomClockIcon} from "../components/ui-base/icons/custom-clock-icon";
import {CustomSexIcon} from "../components/ui-base/icons/custom-sex-icon";
import {CustomPlusCircleIcon} from "../components/ui-base/icons/custom-plus-cicrle-icon";
import Chip from "@material-ui/core/Chip";
import {Tab, Tabs} from "@material-ui/core";
import {CustomTabPanel} from "../components/ui-base/tab-panel";
import emptyLogo from "../img/empty-publisher-logo.png";
import {StyledButton} from "../components/ui-base/button";
import {SuccessModal} from "../components/ui-base/success-modal";
import LoginIcon from '@mui/icons-material/Login';
import {AuthMeModel} from "../models/auth-me.model";
import {useSelector} from "react-redux";
import {RootState} from "../store/root-reducer";
import {useTranslation} from "react-i18next";
import {BookCover} from "../components/shared/book-cover";

const BookViewPage = () => {
    const [openModal, setOpenModal] = React.useState(false);
    const [book, setBook] = React.useState<BookViewModel>(null);
    const [tabActive, setTabActive] = React.useState(0);
    const urlParams = useParams();
    const id: string = urlParams['id'] as string;
    const { t } = useTranslation('common');

    const user: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    const openDownloadBook = () => {
        if (user?.publisher) {

        } else {
            setOpenModal(true);
        }
    }

    useEffect(() => {
        const loadBook = async () => {
            const res = await ManuscriptService.getBasicPreview(id);
            setBook(res);
        }

        if (id) {
            loadBook();
        }
    }, [id]);

    return (
        <StyledBaseGrid container direction={"column"}>
            <StyledMainGrid item xs container direction={"row"}>
                <StyledLeftGrid item container direction={"column"} spacing={1}>
                    <BookCover
                        title={book?.title}
                        description={book?.description}
                        author={''}
                    />

                    <Grid item>
                        <StyledButton type={"button"} color={"transparentViolet"} onClick={() => {openDownloadBook()}}>{t('publicBookView.downloadManuscript')}</StyledButton>
                    </Grid>

                    {(book?.tags.find((tag) => tag.tag_type === 'typeOfNarration') || book?.tags.find((tag) => tag.tag_type === 'realLocation') || book?.tags.find((tag) => tag.tag_type === 'fictionLocation') || book?.tags.find((tag) => tag.tag_type === 'actionTime') || book?.tags.find((tag) => tag.tag_type === 'readerAddInfo')) &&
                    <>
                        <StyledHr/>

                        <Grid item>
                            <StyledDetailsHeader>{t('publicBookView.characteristicManuscript')}</StyledDetailsHeader>
                        </Grid>

                        {book?.tags.find((tag) => tag.tag_type === 'typeOfNarration') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomFeatherIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('publicBookView.narration')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'typeOfNarration')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }

                        {book?.tags.find((tag) => tag.tag_type === 'realLocation') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomMapPinIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('publicBookView.actionPlace')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'realLocation')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }

                        {book?.tags.find((tag) => tag.tag_type === 'fictionLocation') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomGlobeStandIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('publicBookView.fictionPlace')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'fictionLocation')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }

                        {book?.tags.find((tag) => tag.tag_type === 'actionTime') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomHourglassIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('publicBookView.actionTime')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'actionTime')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }
                    </>
                    }

                    {(book?.tags.find((tag) => tag.tag_type === 'readerGender') || book?.tags.find((tag) => tag.tag_type === 'readerAge')) &&
                    <>
                        <StyledHr/>

                        <Grid item>
                            <StyledDetailsHeader>{t('publicBookView.characteristic2')}</StyledDetailsHeader>
                        </Grid>

                        {book?.tags.find((tag) => tag.tag_type === 'readerAge') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomClockIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('age')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'readerAge')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }

                        {book?.tags.find((tag) => tag.tag_type === 'readerGender') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomSexIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('sex')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'readerGender')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }

                        {book?.tags.find((tag) => tag.tag_type === 'readerAddInfo') &&
                        <Grid item container direction={"column"}>
                            <Grid item container direction={"row"}>
                                <Grid item>
                                    <CustomPlusCircleIcon style={{fill: 'none'}}/>
                                </Grid>
                                <Grid>
                                    <StyledDetailsSpan>{t('publicBookView.addInfo')}:</StyledDetailsSpan>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledDetailsP>{book?.tags.find((tag) => tag.tag_type === 'readerAddInfo')?.name || '---'}</StyledDetailsP>
                            </Grid>
                        </Grid>
                        }
                    </>
                    }
                </StyledLeftGrid>

                <Grid item xs>
                    <Grid item container direction={"row"}>
                        <Grid item container direction={"column"} xs={12} sm={12} md={8} spacing={2}>
                            <Grid item>
                                <StyledH6>{book?.title}</StyledH6>
                            </Grid>

                            <Grid item>
                                <StyledSpan1>{t('publicBookView.categories')}:</StyledSpan1>
                                <Grid container direction={'row'} spacing={1}>
                                    {book?.categories.map((category) => (
                                        <Grid item key={category.id} style={{maxWidth: '100%'}}>
                                            <StyledCategoryChip size="small" label={category.name}
                                                                style={{maxWidth: '100%'}}/>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid item>
                                <StyledSpan1>{t('publicBookView.tags')}:</StyledSpan1>
                                <Grid container direction={'row'} spacing={1}>
                                    {book?.tags.filter((tag) => tag.tag_type === 'tag').map((tag) => (
                                        <Grid item key={tag.id} style={{maxWidth: '100%'}}>
                                            <StyledTagChip size="small" label={tag.name} style={{maxWidth: '100%'}}/>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid item>
                                <Tabs value={tabActive} onChange={(event, newValue) => { setTabActive(newValue) }}>
                                    <Tab label={t('publicBookView.tabTitle1')} style={{fontSize: '0.9rem'}}/>
                                    <Tab label={t('publicBookView.tabTitle2')} style={{fontSize: '0.9rem'}}/>
                                    <Tab label={t('publicBookView.tabTitle3')} style={{fontSize: '0.9rem'}}/>
                                </Tabs>

                                <CustomTabPanel value={tabActive} index={0}>
                                    {book?.fragment &&
                                    <StyledDescription>{book?.fragment}</StyledDescription>
                                    }

                                    {!book?.fragment &&
                                    <StyledEmptyDescription>{t('publicBookView.tabEmpty1')}</StyledEmptyDescription>
                                    }
                                </CustomTabPanel>

                                <CustomTabPanel value={tabActive} index={1}>
                                    {book?.description &&
                                    <StyledDescription>{book?.description}</StyledDescription>
                                    }

                                    {!book?.description &&
                                    <StyledEmptyDescription>{t('publicBookView.tabEmpty2')}</StyledEmptyDescription>
                                    }
                                </CustomTabPanel>

                                <CustomTabPanel value={tabActive} index={2}>
                                    {book?.summary &&
                                    <StyledDescription>{book?.summary}</StyledDescription>
                                    }

                                    {!book?.summary &&
                                    <StyledEmptyDescription>{t('publicBookView.tabEmpty3')}</StyledEmptyDescription>
                                    }
                                </CustomTabPanel>
                            </Grid>
                        </Grid>

                        <Grid item container direction={"column"} xs={12} sm={12} md={4} spacing={1} style={{paddingTop: '1rem'}}>
                            <StyledAuthorGrid item container direction={"column"}>
                                <Grid item container direction={"column"} alignItems={"center"} spacing={1}>
                                    <Grid item>
                                        <StyledAuthorLogo style={{backgroundImage: `url(${book?.author.photo?.file || emptyLogo})`}}/>
                                    </Grid>

                                    <Grid item>
                                        <StyledH6Nickname>{book?.author.nickname}</StyledH6Nickname>
                                    </Grid>
                                </Grid>

                                <Grid item container direction={"column"} spacing={1} style={{padding: '0 5%'}}>
                                    <Grid item>
                                        <StyledAuthorSpan>
                                            {t('publicBookView.aboutMe')}:
                                        </StyledAuthorSpan>
                                        <p style={{fontSize: '0.9rem'}}>{book?.author.bio || '-'}</p>
                                    </Grid>

                                </Grid>
                            </StyledAuthorGrid>

                            <StyledLoginGrid item container direction={"column"}>
                                <Grid item>
                                    <StyledLoginLinkTitle>{t('publicBookView.checkBookscout')}</StyledLoginLinkTitle>
                                </Grid>

                                <Grid item container alignContent={"center"} justifyContent={"center"} style={{margin: '1rem 0'}}>
                                    <a href="/register">
                                        <StyledButton type={"button"}>
                                            <LoginIcon/>
                                        </StyledButton>
                                    </a>
                                </Grid>
                            </StyledLoginGrid>
                        </Grid>
                    </Grid>
                </Grid>
            </StyledMainGrid>

            <SuccessModal open={openModal} setOpen={setOpenModal} title={t('publicBookView.noAccessTitle')} description={t('publicBookView.noAccessDesc')} buttonText={t('publicBookView.noAccessButton')} buttonLink={'/login'}/>
        </StyledBaseGrid>
    )
}

export default BookViewPage;

const StyledBaseGrid = styled(Grid)`
  background-color: ${Colors.violet};
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding: 2rem;
  margin: 0;
`;

const StyledMainGrid = styled(Grid)`
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 2rem;
`;

const StyledDetailsSpan = styled('span')`
  color: ${Colors.grayText};
  font-weight: 400;
  margin-left: 5px;
  font-size: 0.9rem;
`;

const StyledDetailsP = styled('p')`
  font-weight: 400;
  font-size: 0.9rem;
`;

const StyledDetailsHeader = styled('p')`
  color: ${Colors.violet};
  font-weight: 500;
`;

const StyledHr = styled('hr')`
  background-color: #E0E0E0;
  border: 0;
  height: 1px;
  width: 80%;
  margin: 1rem auto;
`;

const StyledLeftGrid = styled(Grid)`
  position: relative;
  flex: 0;
  min-width: 230px;
`;

const StyledH6 = styled('h6')`
  font-size: 1.5rem;
  color: ${Colors.violet};
  font-weight: 600;
`;

const StyledSpan1 = styled('span')`
  font-weight: 500;
  font-size: 0.9rem;
  color: ${Colors.darkGray};
`;

const StyledCategoryChip = styled(Chip)`
  background-color: #FBF5FF;
  color: ${Colors.lightViolet};
  border: 1px solid ${Colors.lightViolet};
  font-weight: 500;
`;

const StyledTagChip = styled(Chip)`
  background-color: #F5F5F5;
  color: #424242;
  border: 1px solid #C2C2C2;
  font-weight: 500;
`;

const StyledDescription = styled('p')`
  font-size: 0.9rem;
  white-space: pre-line;
`;

const StyledEmptyDescription = styled('p')`
  font-size: 0.9rem;
  white-space: pre-line;
  color: ${Colors.grayText};
`;

const StyledAuthorGrid = styled(Grid)`
  margin-top: 2rem;
  background: #FBF5FF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding-bottom: 2rem;
`;

const StyledAuthorLogo = styled('div')`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  margin-top: -50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

const StyledH6Nickname = styled('h6')`
  font-size: 1.5rem;
  color: ${Colors.violet};
  font-weight: 600;
  word-break: break-word;
  text-align: center;
`;

const StyledAuthorSpan = styled('span')`
  font-weight: 500;
  font-size: 0.9rem;
  color: ${Colors.violet};
`;

const StyledLoginGrid = styled(Grid)`
  margin-top: 2rem !important;
  background: #FBF5FF;
  border: 1px solid #6714A3;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
`;

const StyledLoginLinkTitle = styled('p')`
  font-size: 1rem;
  font-weight: 600;
  color: ${Colors.lightViolet};
  text-align: center;
`;
